<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="chapter-title2"><b>Preface to<br/>the Second Edition</b></p>
<p class="body-text">The research for the first edition of <i>Behind the Smile</i> was conducted between 1998 and 2000. A decade later, in the summer of 2010, I returned to Barbados to see how tourism had changed, if at all. Despite the global recession (2008–2010), which reduced the numbers of visitors to Barbados, tourism remains essential to the economic well-being of Barbados. Returning to Barbados gave me an opportunity to catch up with many of the people whose narratives are included here. For those I was able to locate I have added short epilogues. I have also added two new narratives, that of Rosie Hartmann, who offers a colorful description of her life and work organizing excursions for cruise ship passengers and locals, and Colin Jordan, who as president of the Barbados Hotel and Tourism Association (BHTA) describes his work trying to educate Barbadians about the importance of tourism to the country. This new edition also includes a description of the tourists who visit Barbados, thus addressing an unfortunate omission in the first edition, and an epilogue describing my field school students' encounters with tourists and tourism.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface1.vue?e3b8acb6